import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { catchError } from 'rxjs/operators'
import { map } from 'rxjs/operators'
import { ErrorObservable } from 'rxjs/observable/ErrorObservable'

import { environment } from 'environments/environment'
import { LoginData } from 'app/models/login-data'
import { Router } from '@angular/router'

@Injectable()
export class AuthService {

  private apiUrl = environment.api.url + environment.api.auth.url
  private apiRedirect = environment.api.url + environment.api.redirect.url

  constructor(private http: HttpClient, private router: Router) {
  }

  authentication(loginData: LoginData,): Observable<any> {
    return this.http.post<any>(this.apiUrl, loginData)
      .pipe(
        map(res => this.saveTokenLocal(res.token)),
        catchError(this.handleError)
      )
  }

  redirect(): Observable<any> {
    return this.http.post<any>(this.apiRedirect, {})
      .pipe(
        map(res => {
          // res.token is for local development
          if (res.token) {
            this.saveTokenLocal(res.token)
            this.router.navigate(['competition'])
          }
          if (res.location) {
            console.log('location', res)
            window.open(res.location, '_self')
          }
        }),
        catchError(this.handleError)
      )
  }

  getTokenLocal(): string {
    return localStorage.getItem('sessionIdToken')
  }

  isAdminUser(): boolean {
    const tokenDecoded = this.decodeToken()
    return tokenDecoded && tokenDecoded.admin
  }

  isUser(): boolean {
    return this.decodeToken()
  }

  logout(): void {
    localStorage.removeItem('sessionIdToken')
  }

  private decodeToken(): any {

    const token = this.getTokenLocal()
    if (token) {
      const base64Url = token.split('.')[1],
        base64 = base64Url.replace('-', '+').replace('_', '/')

      return JSON.parse(window.atob(base64))
    } else {
      return undefined
    }
  }

  private saveTokenLocal(tokenId: string): void {
    localStorage.setItem('sessionIdToken', tokenId)
  }

  private handleError(error: HttpErrorResponse) {
    return new ErrorObservable(error.error)
  }

  public getSubFromToken(): string {
    const tokenDecoded = this.decodeToken()
    if (tokenDecoded) {
      return tokenDecoded.sub
    }
    return tokenDecoded
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts